import { Layout } from "../UI/Layout/Layout.tsx";
import { NavBar } from "../UI/Layout/NavBar.tsx";
import { MainContainer } from "../UI/Layout/MainContainer.tsx";
import { useMoneyTransferInfoQueryStringRepository } from "./useMoneyTransferInfoQueryStringRepository.ts";
import { Card } from "../UI/Card.tsx";
import { Footer } from "../UI/Layout/Footer.tsx";
export const DisplayMoneyTransferInfoScreenPath = `/money-transfer-info`;
function MoneyTransferInfoRow({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <div className={"flex items-center"}>
      <p>
        <label className={"font-bold"}>{label}: </label>
        <span>{value}</span>
      </p>
    </div>
  );
}

export function DisplayMoneyTransferInfoScreen() {
  const { info } = useMoneyTransferInfoQueryStringRepository();
  if (!info) return null; //TODO 404
  return (
    <Layout>
      <NavBar />
      <MainContainer>
        <div className={"max-w-[400px]"}>
          <Card>
            <h3 className={"font-bold text-xl"}>
              Bonifico - {info.productName}
            </h3>
            <p className={"mt-2"}>
              Ecco tutte le informazioni di cui hai bisogno per completare il
              pagamento 💳.
              <br />
              Dopo aver effettuato il bonifico, il tuo account verrà attivato
              appena riceveremo la conferma dalla tua banca (solitamente entro
              1-3 giorni lavorativi ⏳).
            </p>
            <div className={"space-y-1 mt-3"}>
              <MoneyTransferInfoRow label={"IBAN"} value={info.iban} />
              <MoneyTransferInfoRow
                label={"Causale"}
                value={`Iscrizione a ${info.productName} - ${info.customer.firstName} ${info.customer.lastName}`}
              />
              <MoneyTransferInfoRow
                label={"Intestatario"}
                value={info.accountHolderName}
              />
              <MoneyTransferInfoRow label={"BIC"} value={info.bic} />
              <MoneyTransferInfoRow
                label={"Importo"}
                value={`${info.productPrice.amountRemaining / 100} ${info.productPrice.currencyInfo.toUpperCase()}`}
              />
              <p className="font-bold pt-6">
                Per la tua sicurezza:
                <br />
                <span className="font-normal">
                  Norma's Teaching utilizza Stripe, il gateway di pagamento più
                  diffuso al mondo, per garantirti una transazione sicura e
                  affidabile. L'IBAN che visualizzerai è estero, inizia con "IE"
                  poiché indica che il conto ha sede in Irlanda.
                </span>
              </p>
            </div>
          </Card>
        </div>
      </MainContainer>
      <Footer />
    </Layout>
  );
}
